import React, { useRef, useState } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const NKJFlowMonthWise = ({ data, selectedFy }) => {
  const tableRef = useRef();
  const key = ["kmz", "jbp", "sta", "sgrl", "sec", "total"];

  const monthOrder = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];
  if (!Array.isArray(data) || data.length === 0) {
    return <p>No data available</p>;
  }

  const mergedData = {};

  data.forEach((item) => {
    const month = item.a_month;

    if (!mergedData[month]) {
      mergedData[month] = {};
    }

    mergedData[month][item.f_year] = item;
  });

  const fyYears = [...new Set(data.map((d) => d.f_year))];

  ////////////////////////

  const sum = (fy, column) => {
    return data
      .filter((o) => o.f_year === fy)
      .reduce((total, o) => total + Number(o[column] || 0), 0);
  };

  const avg = (fy, column) => {
    const rows = data.filter((o) => o.f_year === fy);
    if (!rows.length) return 0;

    const total = rows.reduce((sum, o) => sum + Number(o[column] || 0), 0);

    return (total / rows.length).toFixed(2);
  };

  ///////////////////////

  return (
    <div className="newUiBody">
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table newUiTable table-striped table-hover  "
          style={{ fontSize: "13px" }}
        >
          <thead>
            <tr className="table-dark text-center">
              <th></th>
              {fyYears.map((fy) => (
                <>
                  <th colSpan={6}>({fy})</th>
                </>
              ))}
            </tr>

            <tr
              className="table-dark text-center"
              style={{ fontWeight: "bold" }}
            >
              <th>MONTH</th>
              {fyYears.map((fy) =>
                key.map((h, i) => (
                  <th key={`${fy}-${i}`} className="text-wrap align-middle">
                    {h.toUpperCase()}
                  </th>
                )),
              )}
            </tr>
          </thead>
          <tbody>
            {monthOrder
              .filter((month) => mergedData[month])
              .map((month) => (
                <tr key={month} className="text-center">
                  <td>{month}</td>

                  {fyYears.map((fy) => {
                    const fyData = mergedData[month][fy] || {};

                    return (
                      <React.Fragment>
                        <td>{fyData["kmz"] || "_"}</td>
                        <td>{fyData["jbp"] || "_"}</td>
                        <td>{fyData["sta"] || "_"}</td>
                        <td>{fyData["sgrl"] || "_"}</td>

                        <td>{fyData["sec"] || "_"}</td>
                        <td className="table-secondary">
                          {fyData["total"] || "_"}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              ))}
          </tbody>
          <tr className="table-dark text-center fw-bold  glassHeading">
            <td>TOTAL</td>

            {fyYears.map((fy) =>
              key.map((k, i) => <td key={`${fy}-total-${i}`}>{sum(fy, k)}</td>),
            )}
          </tr>{" "}
          <tr className="table-dark text-center fw-bold glassHeading">
            <td>AVG</td>

            {fyYears.map((fy) =>
              key.map((k, i) => <td key={`${fy}-total-${i}`}>{avg(fy, k)}</td>),
            )}
          </tr>
        </table>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`NKJ Yard Flow Month wise data  -${selectedFy} }`}
      />
    </div>
  );
};

export default NKJFlowMonthWise;
